import { render, staticRenderFns } from "./FLabelField.vue?vue&type=template&id=6ee2cbc8&"
import script from "./FLabelField.vue?vue&type=script&lang=ts&"
export * from "./FLabelField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports